export const PACKAGE_VERSION = "1.0.5";

